import { render, staticRenderFns } from "./ImportarExportarMargem.vue?vue&type=template&id=e948c4c4"
import script from "./ImportarExportarMargem.vue?vue&type=script&lang=js"
export * from "./ImportarExportarMargem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports